export default __webpack_public_path__ + "static/media/poor-customer-service.c9ed6f29.jpg";